import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MedicalFeePaymentComponent } from './medical-fee-payment.component';
import { SharedMaterialModule } from '../../shared-material.module';
import { MedicalFeePaymentAmountComponent } from '../medical-fee-payment-amount/medical-fee-payment-amount.component';
import { ReactiveFormsModule } from '@angular/forms';
import { MedicalFeePaymentDetailComponent } from '../medical-fee-payment-detail/medical-fee-payment-detail.component';
import { SharedModule } from '../../shared.module';

@NgModule({
  declarations: [
    MedicalFeePaymentComponent,
    MedicalFeePaymentAmountComponent,
    MedicalFeePaymentDetailComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    SharedMaterialModule,
    ReactiveFormsModule,
  ]
})
export class MedicalFeePaymentModule { }
